<template>
  <el-container class="service-information">
    <el-header class="header">
		<span>注销账户</span>
		<i class="el-icon-close" @click="close"></i>
	</el-header>
    <el-main class="main">
		<div class="main_title">请选择注销原因</div>
		<el-radio-group class="radio-group" v-model="radio" @change="changeRadioHandler">
		    <el-radio class="radio" label="需要解绑的手机">需要解绑的手机</el-radio>
		    <el-radio class="radio" label="需要解绑邮箱">需要解绑邮箱</el-radio>
		    <el-radio class="radio" label="安全/隐私顾虑">安全/隐私顾虑</el-radio>
			<el-radio class="radio" label="这是多余的账户">这是多余的账户</el-radio>
			<el-radio class="radio" label="淘宝购物遇到困难">淘宝购物遇到困难</el-radio>
			<el-radio class="radio" label="无法修改会员名">无法修改会员名</el-radio>
			<el-radio class="radio" label="其他">其他</el-radio>
		</el-radio-group>
		<el-input class="textarea" type="textarea" :rows="3" placeholder="请输入其他原因" v-model="textarea" resize="none">
		</el-input>
		<div class="submit-btn" @click="submit">确定</div>
	</el-main>
  </el-container>
</template>

<script>
export default {
  name: 'CancellationReason',
  data(){
	return{
		url:'api/index.php/index',//请求路径
		radio:'',
		textarea:'',
		reason:''//提交注销接口的原因
	}
  },
  props:{
  	User_code:String,
  },
  methods:{
	close(){
		this.$emit('closePop')
	},
	//改变单选框
	changeRadioHandler(value){
		this.reason=value
	},
	// 提交
	async submit(){
		if(!this.reason){
			this.$message.warning('请选择注销原因');
			return
		}
		if(this.reason=='其他'&&this.textarea==''){
			this.$message.warning('选择其他，需要补充文字说明')
			return
		}
		if(this.reason=='其他'){
			this.reason = this.textarea;
		}else{
			this.textarea = '';
		}
		var res = await this.$axios.post('/login/cancellation', {
			User_code: this.User_code,
			cancellation:1,
			cancellation_reason:this.reason
		})
		console.log(res)
		if(res.data.done){
			this.textarea = '';
		}else{
			this.$message.error(res.data.msg);
		}
		this.close();
	},
  },
  created(){
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.service-information{
		width: 600px;
		height: 400px;
		overflow: hidden;
	}
	.header{
		margin: 0;
		padding: 0 24px;
	}
	.header{
		background-color: #354052;
		color: #fff;
		display: flex;
		box-sizing: border-box;
		justify-content: space-between;
		align-items: center;
		height: 40px;
		font-size: 14px;
	}
	.header i{
		font-size: 22px;
	}
	.main{
		margin: 0;
		padding: 0;
	}
	.main .main_title{
		background-color: #e1e7f0;
		padding: 0 24px;
		height: 26px;
		line-height: 26rpx;
		color: #4b73ec;
		margin-top: 6px;
		margin-bottom: 17px;
	}
	.radio-group{
		padding: 0 24px;
		box-sizing: border-box;
	}
	.radio-group .radio{
		width: 27%;
		height: 17px;
		margin-bottom: 11px;
	}
	.textarea{
		padding: 0 24px;
		box-sizing: border-box;
		height: 82px;
	}
	textarea{
		height: 82px;
	}
	.submit-btn{
		margin-left: 24px;
		margin-top: 22px;
		width: 58px;
		height: 22px;
		background-color: #fff;
		border: 1px solid #000;
		text-align: center;
		font-size: 14px;
		line-height: 22px;
	}
</style>
